import React from 'react';

function Notifications() {
  return (
    <div className='text-white'>Notifications</div>
  )
}

export default Notifications;